import { useMemo, useState } from "react"
import { Row, Card, Button, Typography, Checkbox } from "antd"
import { FormattedMessage } from "react-intl"

import FormattedTitle from "../core/FormattedTitle"
import ThreatMetrix from "../compliance/ThreatMetrix"
import { useApply } from "../../hooks/useApply"
import { OfferOverNotification } from "../descriptions"

const { Text } = Typography

export default function CitizensOffer({ offer, acceptOffer, isOverAmount }) {
  const { merchantId, lead } = useApply()

  const [checked, setChecked] = useState(false)

  const reviewDisclosures = useMemo(() => {
    switch (merchantId) {
      case "trek":
        return "CitizensFooter.apply"
      default:
        return "general.reviewDisclosures"
    }
  }, [merchantId])

  return (
    <>
      <OfferOverNotification lead={lead} isOverAmount={isOverAmount} />
      <ThreatMetrix leadId={offer.lead.id} />
      <Card bodyStyle={{ maring: 0 }} style={{ width: "100%" }}>
        {merchantId === "trek" ? (
          <FormattedTitle id="CitizensOffer.headerTitle" size="medium" />
        ) : (
          <>
            <img src={offer.originator.image_url} alt="lender-logo" />
            <br />
            <br />
          </>
        )}

        <FormattedTitle id="CitizensOffer.title" size="medium" />
        <FormattedTitle id="CitizensOffer.subtitle" size="small" />
        <p style={{ fontSize: 24, margin: 0, fontWeight: 300 }}>
          {offer.amount}
        </p>
        <br />
        {merchantId !== "trek" && (
          <div>
            <b>
              <FormattedMessage id="general.purchaseApr" />
              :&nbsp;&nbsp;
            </b>
            {offer.apr}
          </div>
        )}
        {merchantId !== "trek" && (
          <div>
            <b>
              <FormattedMessage id="general.interestType" />
              :&nbsp;&nbsp;
            </b>
            {offer.intro_term && offer.apr === "0%"
              ? "Same As Cash"
              : "Standard"}
          </div>
        )}
        {offer.payment ? (
          <div>
            <b>
              <FormattedMessage id="general.payment" />
              :&nbsp;&nbsp;
            </b>
            {offer.payment}
          </div>
        ) : null}
        {merchantId !== "trek" && (
          <>
            <p style={{ marginTop: 15, fontStyle: "italic", fontSize: 11 }}>
              <FormattedMessage id="CitizensOffer.terms" />
            </p>
            <p>
              <FormattedMessage id="CitizensOffer.review" />
            </p>
          </>
        )}

        {merchantId === "trek" && (
          <>
            <Row
              justify="center"
              style={{
                marginBottom: 20,
                marginTop: 20,
                backgroundColor: "#3A8259",
                padding: 10,
              }}
            >
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 17,
                  color: "white",
                }}
              >
                Looks like you might be eligible to finance your purchase for 0%
                - 5% APR over 6 - 18 months!
              </Text>
            </Row>
            <Row
              justify="center"
              style={{
                marginBottom: 20,
                marginTop: 20,
                padding: 10,
              }}
            >
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 16,
                  color: "black",
                }}
              >
                Final payment terms will be based on your actual purchase amount
              </Text>
            </Row>
            <Row justify="center" style={{ marginBottom: 20, marginTop: 20 }}>
              <Checkbox name="agree" onChange={() => setChecked(!checked)}>
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 12,
                    fontColor: "black",
                  }}
                >
                  I would like to apply for this line of credit according to the{" "}
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.citizensbank.com/disclosures/genericapr-ri-citizenspay.aspx"
                  >
                    Citizens Pay Line of Credit Terms and Conditions
                  </a>
                  . I understand this application will result in a hard credit
                  inquiry which may impact my credit score. I acknowledge that I
                  have accessed, read, and agree to your{" "}
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.citizensbank.com/account-safeguards/privacy.aspx"
                  >
                    Privacy Policy
                  </a>
                  ,{" "}
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.citizensbank.com/disclosures/apr-econsent.aspx"
                  >
                    Consent to Electronic Documents
                  </a>
                  , and{" "}
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.citizensbank.com/disclosures/apr-verification-of-identity.aspx"
                  >
                    Verification of My Identity
                  </a>
                  . I authorize Citizens Pay to obtain my credit report to
                  determine financing options and share my information with
                  retailers about my prequalification request, application, and
                  line of credit.
                </Text>
              </Checkbox>
            </Row>
          </>
        )}
        <Row justify="center">
          <Button
            type="primary"
            onClick={acceptOffer}
            disabled={isOverAmount || (merchantId === "trek" && !checked)}
          >
            <FormattedMessage id={reviewDisclosures} />
          </Button>
        </Row>
      </Card>
    </>
  )
}
